class PasswordPage extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = null;
    this.toggleText = null;
    this.panels = new Map();
    this.passwordInput = null;
    this.defaultView = "subscribe";
    this.onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    this.toggleButton = this.querySelector("[data-password-toggle]");
    this.toggleText = this.querySelector("[data-password-toggle-text]");
    this.passwordInput = this.querySelector("[data-password-input]");
    this.querySelectorAll("[data-password-panel]").forEach((panel) => {
      this.panels.set(panel.dataset.passwordPanel, panel);
    });

    if (this.querySelector("[data-password-error]")) {
      this.defaultView = "password";
    }

    this.setView(this.defaultView);

    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", this.onToggle);
    }
  }

  disconnectedCallback() {
    if (this.toggleButton) {
      this.toggleButton.removeEventListener("click", this.onToggle);
    }
  }

  onToggle() {
    const nextView = this.currentView === "password" ? "subscribe" : "password";
    this.setView(nextView);
  }

  setView(view) {
    this.currentView = view;
    this.panels.forEach((panel, key) => {
      panel.classList.toggle("hidden", key !== view);
    });

    if (this.toggleText && this.toggleButton) {
      this.toggleText.textContent =
        view === "password"
          ? this.toggleButton.dataset.labelCancel || "Cancel"
          : this.toggleButton.dataset.labelEnter || "Enter Password";
    }

    if (view === "password" && this.passwordInput) {
      this.passwordInput.focus();
    }
  }
}

customElements.define("password-page", PasswordPage);
